<template lang="html">
  <nav>
    <router-link :to="{ name: 'projects' }"><txt phrase="Projects"></txt></router-link>
    <router-link :to="{ name: 'info' }"><txt phrase="Information"></txt></router-link>
  </nav>
</template>

<script>
const Txt = () => import( /* webpackChunkName: "Text" */ '@/components/Text.vue')
export default {
  components: {
    Txt
  }
}
</script>

<style lang="scss" scoped>
nav {
    a {
        padding-left: calc(0.5 * var(--lh));
        @media only screen and (max-width:1024px) {
            display: block;
            text-align: right;
        }
        &.router-link-active {
            .phrase {
                .rest {
                    transform: translateY(0) !important;
                }
            }
        }
    }
}
</style>
